import React from 'react';
import DButton from '@/components/Global/DButton';
import clsx from 'clsx';
import ArrowRightIcon from '@/shared/icons/ArrowRightIcon';

const PlanCardButton = ({
  user,
  tier,
  isAdvanced,
  loadingTierId,
  loadingDowngradeTierId,
  handleUpgrade,
  handleDowngrade,
  period,
}) => {
  const isCurrentPlan = user?.tier_rank === tier.rank && !user?.tier_on_trial;
  const isDowngrade = user?.tier_rank > tier.rank && tier.name !== 'Enterprise' && !user?.tier_on_trial;
  const isUpgrade = (user?.tier_rank || 0) < tier.rank && tier.name !== 'Enterprise' && !user?.tier_on_trial;
  const isTrialUpgrade = tier?.name !== 'Enterprise' && user?.tier_on_trial;

  if (isCurrentPlan) {
    return (
      <DButton
        variant="light"
        fullWidth
        className="relative overflow-hidden h-v3-xxl py-[10px] px-v3-md flex flex-col justify-center items-center self-stretch !rounded-v3-lg bg-v3-purple-lightest text-v3-purple-primary font-inter-variable text-sm font-medium leading-[20px] text-center !mt-auto"
      >
        Current Plan
      </DButton>
    );
  }

  if (isDowngrade) {
    return (
      <DButton
        fullWidth
        loading={loadingDowngradeTierId === tier.id}
        onClick={() => {
          handleDowngrade(tier);
        }}
        className="h-v3-xxl py-[10px] px-v3-md flex flex-col justify-center items-center self-stretch !rounded-v3-lg bg-v3-purple-lightest text-v3-purple-primary hover:bg-v3-purple-light font-inter-variable text-sm font-medium leading-[20px] text-center"
      >
        Downgrade
      </DButton>
    );
  }

  if (isUpgrade || isTrialUpgrade) {
    return (
      <DButton
        fullWidth
        loading={loadingTierId === tier.id}
        onClick={() => handleUpgrade(tier.id, tier.name.toLowerCase())}
        className={clsx(
          'h-[40px] py-[10px] px-v3-md flex  justify-center items-center self-stretch !rounded-v3-lg font-inter-variable text-sm font-medium leading-[20px] text-center',
          isAdvanced
            ? 'bg-v3-purple-primary text-[#fff] hover:bg-v3-purple-light'
            : 'bg-v3-purple-lightest text-v3-purple-primary hover:bg-v3-purple-light'
        )}
      >
        {period === 'weekly' ? 'Upgrade' : period === 'yearly' ? 'Move to Annual' : 'Upgrade'}
        <ArrowRightIcon className='size-3' />
      </DButton>
    );
  }

  return null;
};

export default PlanCardButton;

